import { Component } from 'react'
import { connect } from 'react-redux'
import store from 'store2'
import moment from 'moment'
import setQuery from 'set-query-string'
import isEmpty from 'lodash/isEmpty'
import pickBy from 'lodash/pickBy'
import get from 'lodash/get'
import filter from 'lodash/filter'
import each from 'lodash/each'
import isArray from 'lodash/isArray'
import map from 'lodash/map'
import { FormattedMessage } from 'react-intl'
import ReactTooltip from 'react-tooltip'
import { FiltersDr } from '../components'
import StickyHeaderDr from '../components/search-dr/StickyHeaderDr'
import { parseQuery } from '../utils'
import ResortComponent from '../components/search-dr/ResortComponent'
import { prepareGuestSplitting } from '../components/resort/ResortPricing'
import SearchMap from '../components/search-dr/SearchMap'
import MobileFilterToggleDr from '../components/search-dr/MobileFilterToggleDr'

const SORT_BY = [
  {
    title: <FormattedMessage id='feature' defaultMessage='Featured' />,
    value: '-travel_featured_rating',
  }, {
    title: <FormattedMessage id='cheapest' defaultMessage='Cheapest' />,
    value: 'price_sum',
  }, {
    title: <FormattedMessage id='guest_rating' defaultMessage='Guest ratings' />,
    value: '-tripadvisor_rating',
  }, {
    title: <FormattedMessage id='hotel_category' defaultMessage='Hotel category' />,
    value: '-stars',
  }]

const filtersKeys = [
  'dateStart',
  'dateTo',
  'nights',
  'totalGuests',
  'rating',
  'stars',
  'resort_size',
  'location',
  'courses',
  'ordering',
  'meal_plan',
  'marine_life_critters',
  'parameters',
  'themes',
  'harbours',
  'price',
  'sponsors',
  'view',
  'resort_amenities',
  'diving_facilities',
  'dive_center_affiliations',
  'diving_equipment',
  'shop',
  'tag',
]

const valueFilter = [
  'nights',
  'view',
  'dateStart',
  'dateTo',
  // 'price_sum_0',
  // 'price_sum_1',
  'ordering',
  'shop',
]

export const guestPickerKeys = [
  'divers',
  'nonDivers',
  'students',
  'guests_split',
  'rooms',
]

const filtersToClean = [
  'rating',
  'stars',
  'resort_size',
  'location',
  'courses',
  'meal_plan',
  'marine_life_critters',
  'parameters',
  'themes',
  'harbours',
  'price',
  'sponsors',
  'resort_amenities',
  'diving_facilities',
  'dive_center_affiliations',
  'diving_equipment',
  'total_number_of_rooms_1',
  'total_number_of_rooms_0',
  'tag',
]
class SearchPageComponent extends Component {
  constructor(props) {
    super(props)

    const date = store('date')
    const roomParams = store.get('roomParams') || {}
    if(date) {
      setQuery({ dateStart: date[0], dateTo: date[1] })
    }
    if(store('duration')) {
      setQuery({ nights: store('duration') })
    }

    let selectedParams = parseQuery()
    let filtersCount = 0
    let filterObject = {}
    let totalGuests = 0

    if(selectedParams) {
      each(selectedParams, function(val, key) {
        if(filtersKeys.indexOf(key) >= 0) {
          if(valueFilter.indexOf(key) >= 0) {
            filterObject[key] = key === 'nights' && val ? +val : val
          } else if(isArray(val)) {
            filterObject[key] = {}
            each(val, function(v) {
              filterObject[key][v] = true
            })
            filtersCount++
          } else {
            filterObject[key] = {}
            filterObject[key][val] = true
            filtersCount++
          }
        }
      })
    }

    if(roomParams) {
      totalGuests += roomParams.divers + roomParams.nonDivers + roomParams.students
    }

    this.state = {
      selectedParams: {
        ordering: SORT_BY[0].value,
        view: 'resorts',
        ...selectedParams,
        nights: selectedParams.nights ? +selectedParams.nights : undefined,
        divers: roomParams.divers,
        students: roomParams.students,
        nonDivers: roomParams.nonDivers,
        rooms: roomParams.rooms,
        guests_split: totalGuests ? prepareGuestSplitting(get(roomParams, 'guest_split', get(roomParams, 'details', [roomParams]))) : null,
      },
      locationCoordinates: this.props.locationCoordinates,
      getNewData: false,
      selectedFilters: filterObject,
      numberOfBoats: this.props.totalCount || 0,
      numberOfTrips: 0,
      numberOfBoatsParent: 0,
      filtersCount,
    }
  }

  updateParams = (params, clearPage) => {
    const { selectedParams } = this.state
    let filtersCount = 0

    if(clearPage) {
      this.setState({
        page: 1,
      })
      setQuery({ page: 1 })
    }

    this.setState({
      selectedFilters: {
        ordering: SORT_BY[0].value,
        view: 'resorts',
        ...this.state.selectedFilters,
        ...params,
      },
    }, () => {
      let obj = {}
      let guests = {
        divers: selectedParams.divers,
        students: selectedParams.students,
        nonDivers: selectedParams.nonDivers,
        rooms: selectedParams.rooms,
        guests_split: selectedParams.guests_split,
      }
      each(this.state.selectedFilters, function(val, key) {
        if(filtersKeys.indexOf(key) >= 0) {
          if(valueFilter.indexOf(key) >= 0) {
            obj[key] = key === 'nights' && val ? +val : val
          } else if(key === 'is_promotion' && val.promotion) {
            obj[key] = val.promotion
          } else {
            obj[key] = filter(map(val, function(v, k) {
              if(v) {
                return +k
              }

              return null
            }), function(v) {
              return v || typeof v === 'number'
            })

            if(key === 'resort_size') {
              let resortSizeOptions = filter(window.RESORT_SIZE, function(v) {
                return obj[key].indexOf(v.id) !== -1
              })
              let roomNumbers = resortSizeOptions.reduce(function(acc, val) {
                acc[0] = (acc[0] === undefined || val.total_number_of_rooms_0 < acc[0]) ? val.total_number_of_rooms_0 : acc[0]
                acc[1] = (acc[1] === undefined || val.total_number_of_rooms_1 > acc[1]) ? val.total_number_of_rooms_1 : acc[1]
                return acc
              }, [])

              obj.total_number_of_rooms_0 = roomNumbers[0]
              obj.total_number_of_rooms_1 = roomNumbers[1]
            }
          }

          if((isArray(obj[key]) && obj[key].length) || (key === 'is_promotion' && obj[key])) {
            filtersCount++
          }
        } else if(guestPickerKeys.indexOf(key) >= 0) {
          guests[key] = key === 'guests_split' && val ? prepareGuestSplitting(val) : val
        }
      })

      setQuery(obj)

      obj = pickBy(obj, function(val, key) {
        if(typeof val === 'object') {
          return !isEmpty(val)
        }
        if(typeof val === 'number') {
          return true
        }
        return val
      })

      if(obj.dateStart) {
        store('departure_date_custom', obj.dateStart)
        store('duration', obj.nights)
        store('date', [obj.dateStart, moment(obj.dateStart).add(obj.nights || 30, 'd').format('YYYY-MM-DD')])
        store.remove('departure_date')
      } else {
        store.remove('departure_date')
        store.remove('departure_date_custom')
        store.remove('date')
      }

      this.setState({
        selectedParams: {
          ...obj,
          ...guests,
        },
        filtersCount,
      })
    })
  }

  clearSelectedFilters = () => {
    let cleanObj = {}
    each(filtersToClean, function(filter) {
      cleanObj[filter] = undefined
    })

    setQuery(cleanObj)

    this.setState({
      selectedFilters: {
        ...this.state.selectedFilters,
        ...cleanObj,
      },
      selectedParams: {
        ...this.state.selectedFilters,
        ...cleanObj,
      },
      filtersCount: 0,
    })
  }

  clearDates = () => {
    this.setState({
      selectedFilters: {
        ...this.state.selectedFilters,
        departure_date_month: null,
      },
      selectedParams: {
        ...this.state.selectedFilters,
        departure_date: undefined,
        departure_date_month: undefined,
      },
    })

    setQuery({ departure_date: null })
    store.remove('departure_date')
    store.remove('departure_date_custom')
    store.remove('date')
  }

  updateOrdering = (item) => {
    if(this.state.selectedParams.ordering === item.value) {
      if(item.value[0] === '-') {
        item.value = item.value.substr(1)
      } else {
        item.value = '-' + item.value
      }
    }

    this.updateParams({
      ordering: item.value,
    })
  }

  isActiveFilter = (item) => {
    let className = 'option '
    let selectedOption = this.state.selectedParams.ordering
    let indexOf = item.value.indexOf(selectedOption && selectedOption[0] === '-' ? selectedOption.substring(1) : selectedOption)

    if(indexOf !== -1 && indexOf <= 1) {
      className += 'active '
    }
    if(item.value.indexOf('-') === 0) {
      className += 'desc'
    }

    return className
  }

  triggerApi = () => {
    this.setState({
      getNewData: !this.state.getNewData,
    })
  }

  setNumberOfItems = (number, type) => {
    let obj = { [type]: number }

    this.setState(obj)
  }

  setNumberOfBoatsParent = (number) => {
    this.setState({
      numberOfBoatsParent: number,
    })
  }

  openModal() {
    this.setState({ modalIsOpen: true })
  }

  afterOpenModal() {
    // references are now sync'd and can be accessed.
    this.subtitle.style.color = '#f00'
  }

  closeModal() {
    this.setState({ modalIsOpen: false })
  }

  onMapMove = (locationCoordinates) => {
    this.setState({
      locationCoordinates,
    })
  }

  isAllParamsSelected() {
    const { selectedParams } = this.state

    return selectedParams.dateStart && selectedParams.nights && selectedParams.guests_split && (selectedParams.divers + selectedParams.students + selectedParams.nonDivers)
  }

  render() {
    const { selectedParams, locationCoordinates } = this.state
    const totalGuests = selectedParams.divers + selectedParams.nonDivers + selectedParams.students
    return (
      <div className='search-page-la search-page-dr'>
        <StickyHeaderDr
          locationTitle={this.props.title}
          dateFrom={selectedParams.dateStart}
          dateTo={selectedParams.dateTo}
          duration={selectedParams.nights}
          guestsInRoom={selectedParams} />
        <ReactTooltip effect='solid' id='global' />
        <div className={`search-wrapper ${selectedParams.view === 'map' ? 'full-width' : ''}`}>
          <div className='main-content'>
            <FiltersDr
              triggerApi={this.triggerApi}
              liveaboardDetails={this.props.liveaboardDetails}
              isWidget={this.props.isWidget}
              selectedParams={this.state.selectedParams}
              selectedFilters={this.state.selectedFilters}
              items={this.props.filters}
              title={this.props.title}
              updateParams={this.updateParams}
              clearDates={this.clearDates}
              clearSelectedFilters={this.clearSelectedFilters}
              trustpilotLocale={this.props.trustpilotLocale}
              filtersCount={this.state.filtersCount}
            />
            { selectedParams.view === 'map' ? (
              <SearchMap totalGuests={totalGuests} isAllParamsSelected={this.isAllParamsSelected()} selectedParams={selectedParams} locationCoordinates={locationCoordinates} onMapMove={this.onMapMove} />
            ) : (
              <div className='result-list'>
                <div className='results-head'>
                  <h1>
                    <FormattedMessage
                      id='search.title.resorts'
                      values={{
                        qty: this.state.numberOfBoats,
                        location: this.props.inTitle,
                      }}
                      defaultMessage='{ qty, plural, one {# dive resort } other {# dive resorts } } { location }' />
                  </h1>
                  <MobileFilterToggleDr isActiveFilter={this.isActiveFilter} updateOrdering={this.updateOrdering} sorting={SORT_BY} filtersCount={this.state.filtersCount} updateParams={this.updateParams} />
                </div>
                <div className='search-ordering'>
                  <label className='bold'>
                    <FormattedMessage id='sort_by' defaultMessage='Sort by' />:
                  </label>
                  <ul className='pt-selector' >
                    {
                      SORT_BY.map((sort, index) => {
                        return (<li key={index} onClick={() => this.updateOrdering(sort)} className={this.isActiveFilter(sort)}>
                          { sort.title }
                          <span className='arrow'>↓</span>
                        </li>)
                      })
                    }
                  </ul>
                </div>
                { selectedParams.students && +selectedParams.nights < 5 ? (
                  <div className='warning-message'>
                    <div className='warning-message__wrapper'>
                      <p className='warning-message__text'>
                        <i className='font-icons icon-warning' />
                        <FormattedMessage id='open_water_course_duration' defaultMessage='The PADI Open Water Course usually takes 4 days. We recommend you stay at least 5 nights. Please contact our staff if you want to book a shorter trip to make sure it is possible.' />
                      </p>
                      <button className='btn-red' onClick={() => document.getElementById('livechat').click()}>
                        <FormattedMessage id='contact_us' defaultMessage='Contact us' />
                      </button>
                    </div>
                  </div>
                ) : '' }
                <ResortComponent
                  isAllParamsSelected={this.isAllParamsSelected()}
                  setNumberOfItems={this.setNumberOfItems}
                  selectedParams={selectedParams}
                  getNewData={this.state.getNewData}
                  {...this.props}
                  totalGuests={totalGuests} />

                { this.props.totalCount < 10 ? (
                  <div className='top-level-items'>
                    <h2>
                      <FormattedMessage
                        id='search.other_dr'
                        defaultMessage='{qty} other {qty, plural, one {dive resort} other {dive resorts}} {location}'
                        values={{ qty: this.state.numberOfBoatsParent, location: this.props.parentTitle }} />
                    </h2>
                    <div className='update-search-wrapper'>
                      <a href={this.props.parentUrl} className='btn-red'>
                        <i className='font-icons find-icon' />
                        <FormattedMessage id='update_search' defaultMessage='Update search' />
                      </a>
                      <FormattedMessage id='search.dive_resorts_in' defaultMessage='Dive resorts {location}' values={{ location: this.props.parentTitle }} />
                    </div>
                    <ResortComponent
                      isAllParamsSelected={this.isAllParamsSelected()}
                      totalGuests={totalGuests}
                      getNewData={this.state.getNewData}
                      parentElement
                      setNumberOfItems={this.setNumberOfBoatsParent}
                      selectedParams={selectedParams}
                      slug={this.props.parentSlug}
                      model={this.props.parentModel}
                      pk={this.props.parentPk}
                      liveaboardDetails={this.props.parentLiveaboardDetails} />
                  </div>) : '' }
              </div>)
            }
          </div>
        </div>
      </div>
    )
  }
}

export default connect(
  state => ({
    numberOfTrips: state.numberOfTrips,
    pageLoader: state.pageLoader,
  })
)(SearchPageComponent)
